import { makeStyles } from '@cuda-networks/bds-core'

export default makeStyles(theme => ({
  wrapper: {
    paddingTop: theme.layout.navbarHeight,
    height: '100%'
  }
}))
